import Cookies from 'js-cookie';
import { authHeader } from './auth-header';

// Authenticated JSON fetch with session-expiry handling.
// Auth-middleware rejections (expired/invalid JWT) come back as bare
// 401/403 text; business denials are JSON with a status field — only
// the former should force a fresh sign-in.
export async function apiJson(url, opts = {}) {
  const headers = Object.assign(
    { 'Content-Type': 'application/json' },
    authHeader(),
    opts.headers || {}
  );
  const res = await fetch(url, {
    method: opts.method || 'GET',
    headers,
    body: opts.body ? JSON.stringify(opts.body) : undefined
  });
  const text = await res.text();
  let json = null;
  try { json = JSON.parse(text); } catch (e) { /* not json */ }

  if (res.status === 401 || res.status === 403) {
    var forceLogout = json === null || (json && (json.status === 'session_expired' || json.status === 'account_not_active'));
    if (forceLogout) {
      Cookies.remove('token');
      window.location.href = '/?login=true';
      return { status: 'session_expired', message: 'Your session expired — sign in again.' };
    }
  }

  return json !== null ? json : { status: 'failed', message: text || 'HTTP ' + res.status };
}
